import React from "react";
import {
  faCog,
  faComment,
  faDumbbell,
  faHome,
  faInfoCircle,
  faLock,
  faPlusCircle,
  faQuestionCircle,
  faShoppingBasket,
  faSignOutAlt,
  faUserCog,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import "./DashboardNavigation.css";
const DashboardNavigation = ({ dToken }) => {
  const signOutHandler = () => localStorage.removeItem("user");
  return (
    <>
      <div className="dashboard_navigation">
        <ul>
          <li>
            <Link to="/home">
              <span className="icon">
                <FontAwesomeIcon icon={faDumbbell} />
              </span>
              <span className="title">
                <h2>Gym Hero</h2>
              </span>
            </Link>
          </li>
          {dToken.role === "admin" && (
            <>
              <li>
                <Link to="/dashboard">
                  <span className="icon">
                    <FontAwesomeIcon icon={faHome} />
                  </span>
                  <span className="title">Dashboard</span>
                </Link>
              </li>
              <li>
                <Link to="/dashboard/addServices">
                  <span className="icon">
                    <FontAwesomeIcon icon={faPlusCircle} />
                  </span>
                  <span className="title">Add Service</span>
                </Link>
              </li>
              <li>
                <Link to="/dashboard/users">
                  <span className="icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </span>
                  <span className="title">Users</span>
                </Link>
              </li>
              <li>
                <Link to="/dashboard/makeAdmin">
                  <span className="icon">
                    <FontAwesomeIcon icon={faUserCog} />
                  </span>
                  <span className="title">Make Admin</span>
                </Link>
              </li>
            </>
          )}
          <li>
            <Link to="/dashboard/orders">
              <span className="icon">
                <FontAwesomeIcon icon={faShoppingBasket} />
              </span>
              <span className="title">Orders</span>
            </Link>
          </li>
          {dToken.role === "admin" && (
            <li>
              <Link to="/dashboard/messages">
                <span className="icon">
                  <FontAwesomeIcon icon={faComment} />
                </span>
                <span className="title">Message</span>
              </Link>
            </li>
          )}
          {dToken.role === "admin" && (
            <li>
              <Link to="/dashboard/reviews">
                <span className="icon">
                  <FontAwesomeIcon icon={faInfoCircle} />
                </span>
                <span className="title">Reviews</span>
              </Link>
            </li>
          )}
          <li>
            <Link to="/dashboard/giveReview">
              <span className="icon">
                <FontAwesomeIcon icon={faPlusCircle} />
              </span>
              <span className="title">Give Review</span>
            </Link>
          </li>
          <li>
            <Link to="/dashboard/help">
              <span className="icon">
                <FontAwesomeIcon icon={faQuestionCircle} />
              </span>
              <span className="title">Help</span>
            </Link>
          </li>
          {dToken.role === "admin" && (
            <li>
              <Link to="/dashboard/settings">
                <span className="icon">
                  <FontAwesomeIcon icon={faCog} />
                </span>
                <span className="title">Settings</span>
              </Link>
            </li>
          )}
          <li>
            <Link to="/dashboard/change-password">
              <span className="icon">
                <FontAwesomeIcon icon={faLock} />
              </span>
              <span className="title">Password</span>
            </Link>
          </li>
          <li>
            <Link to="#" onClick={signOutHandler}>
              <span className="icon">
                <FontAwesomeIcon icon={faSignOutAlt} />
              </span>
              <span className="title">Sign Out</span>
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default DashboardNavigation;
